import React, { useState } from "react";
import Navbar from "./components/Navbar";
import NewsLetter from "./components/NewsLetter";
import "./css/Home.css";
import "./css/CustomModal.css";

import heroBg from "../images/HomeBgBanner.png";
import heroImage from "../images/HomeRightupdated.png";
import heroImage2 from "../images/HomeRight2.png";

// You can replace these with actual image paths or icons (like react-icons)
import icon1 from "../images/learningicon.png";
import icon2 from "../images/forumicon5.png";
import icon3 from "../images/kirnavaliicon1.png";
import icon4 from "../images/schoolerp.png";
import icon5 from "../images/softwareicon.png";
import icon6 from "../images/mobileicon.png";

// New Section Image (Update path to your actual image)
import aboutImage from "../images/AboutRight.png";

// NEW Imports for this section (Update paths to your actual files)
import circlesBg from "../images/Banner5.png";

// NEW Imports for this section (Update paths to your actual files)
import cardsBg from "../images/Banner2.png";
import cardImg1 from "../images/CardImage1.png";
import cardImg2 from "../images/CardImage2.png";
import cardImg3 from "../images/CardImage3.png";

import { Link } from "react-router-dom";

import twinBg from "../images/Banner3.png"; // New background image asset
import circle2Icon1 from "../images/HomeIcon.png"; // Icon for the first circle
import circle2Icon2 from "../images/HomeIcon.png"; // Icon for the second circle

import dynamicBg from "../images/Banner6.png"; // New background image asset
import thumb1 from "../images/Resources1.jpg";
import thumb2 from "../images/Resources2.png";
import thumb3 from "../images/Resources3.png";
import thumb4 from "../images/Resources4.png";
// Add assets for the expandable cards as well

// Import your images (make sure these paths match your project setup)
import diagnosticImg from "../images/service1.png";
import lmsImg from "../images/service2.png";
import schoolImg from "../images/service3.png";
import instituteImg from "../images/service4.png";
import admissionImg from "../images/service5.png";
import forumImg from "../images/service6.png";

import Footer from "./components/Footer";

import { FaCheckCircle, FaRocket, FaArrowRight, FaUserPlus, FaChalkboardTeacher, FaUserGraduate, FaUsers, FaTimes, FaHourglassHalf } from "react-icons/fa";
import DownloadApp from "./components/DownloadApp";

function Home() {

    // Array holding all box content items
    const allBoxes = [
        { id: 1, img: thumb3, title: "CBSE", subtitle: "Class 07 - 10", link: "https://cbse.crestest.com/" },
        { id: 2, img: thumb1, title: "ICSE", subtitle: "Class 07 - 10", link: "https://icse.crestest.com/" },
        { id: 3, img: thumb2, title: "NTSE", subtitle: "Class 10", link: "https://ntse.crestest.com/" },
        { id: 4, img: thumb4, title: "NSTSE", subtitle: "Class 10", link: "https://nstse.crestest.com/" },

        // These hidden boxes will reveal when "View More" is triggered
        // { id: 5, img: thumb5, title: "Cyber Security", subtitle: "Network Protocol", link: "#" },
        // { id: 6, img: thumb6, title: "AI Integration", subtitle: "Machine Models", link: "#" },
    ];

    // State tracker toggles whether all elements show or just the initial 4
    const [showAll, setShowAll] = useState(false);

    // Filters items dynamically based on the toggle state
    const visibleBoxes = showAll ? allBoxes : allBoxes.slice(0, 4);

    const [activeTooltip, setActiveTooltip] = useState(null);

    const [showComingSoonModal, setShowComingSoonModal] = useState(false);

    const handleCloseComingSoonModal = () => {
        setShowComingSoonModal(false);
    };

    const featureDetails = {
        one: {
            title: "Premier Learning Hub",
            desc: "Access Crestest's comprehensive LMS with online learning, assessments, personalized practice, and performance tracking.",
            points: ["AI-Powered Learning", "Online Assessments"]
        },
        two: {
            title: "Scholars' Forum & Quiz Arena",
            desc: "Collaborate with fellow learners, participate in discussions, and test your knowledge through interactive quizzes.",
            points: ["Community Discussions", "Quiz Competitions"]
        },
        three: {
            title: "Kirnavali National Challenge Portal",
            desc: "Measure academic growth through nationwide challenges, performance analysis, and skill-based competitions.",
            points: ["National Challenge", "Academic Analytics"]
        },
        four: {
            title: "Crestest School ERP",
            desc: "A complete school management solution for administrators, teachers, students, and parents.",
            points: ["School Management", "Parent & Teacher Portal"]
        },
        five: {
            title: "Custom EdTech Software Solutions",
            desc: "Tailor-made educational software solutions designed to meet the unique needs of schools, institutes, and organizations.",
            points: ["Custom Development", "Scalable Solutions"]
        },
        six: {
            title: "Mobile Application",
            desc: "Learn anytime, anywhere with the Crestest mobile app featuring seamless access to courses, tests, and progress reports.",
            points: ["Learn on the Go", "Instant Progress Tracking"]
        }
    };

    // State to track which circle's modal is open (null means closed)
    // Maps to: 0 -> Register Here, 1 -> Teacher Resources, 2 -> Student Hub, 3 -> For Parents
    const [activeModalIndex, setActiveModalIndex] = useState(null);

    // Your provided service tabs content
    const serviceTabs = [
        {
            name: "Free Diagnostic Test",
            image: diagnosticImg,
            pointers: [
                "Free chapter-wise practice tests & concept maps",
                "AI-generated performance insights & report card",
                "Strength & weakness analysis with study plan",
                "Time, accuracy & chapter-wise progress tracking"
            ],
            linkText: "Start Free Diagnostic Test",
            linkUrl: "https://crestestlearning.com/"
        },
        {
            name: "Complete CBSE Curriculum Mastery",
            image: lmsImg,
            pointers: [
                "Unlimited premium chapter-wise & full-length tests",
                "AI-powered analytics with personalized study plans",
                "Adaptive question engine & weak area detection",
                "Exam-ready simulations with parent growth insights"
            ],
            linkText: "Explore Premium Learning",
            linkUrl: "https://lms.crestest.com/page-login"
        },
        {
            name: "School Management",
            image: schoolImg,
            pointers: [
                "Digital admission & enrollment workflow",
                "Learning management, assignments & online exams",
                "Student performance analytics & AI-ready report cards",
                "Role-based administration with enterprise security"
            ],
            linkText: "Explore School ERP",
            linkUrl: "https://school.crestest.com"
        },
        {
            name: "Institute Management",
            image: instituteImg,
            pointers: [
                "Smart admission pipeline & document management",
                "Lecture hosting, LMS & assignment automation",
                "Online exams with proctoring & instant evaluation",
                "Analytics, audit trails & role-based administration"
            ],
            linkText: "Explore Institute ERP",
            linkUrl: "https://institute.crestest.com"
        },
        {
            name: "Admission Management",
            image: admissionImg,
            pointers: [
                "Smart lead capture & digital admission forms",
                "Secure document verification & interview scheduling",
                "Real-time application tracking & fee collection",
                "Instant receipts with automated payment reconciliation"
            ],
            linkText: "Manage Admissions",
            linkUrl: "https://admission.crestestlearning.com"
        },
        {
            name: "Forum",
            image: forumImg,
            pointers: [
                "Create public & private posts with discussions",
                "Like, comment, share & connect with learners",
                "Community quizzes, leaderboards & badges",
                "Notifications, moderation & hashtag discovery"
            ],
            linkText: "Join Scholars' Forum",
            linkUrl: "https://forum.crestest.com/login"
        }
    ];

    // Helper config to tailor modal heading/subtext per circle type if needed, or share globally
    const circleModalConfig = [
        {
            title: "Register & Get Started",
            subtitle: "Choose a service below to begin your journey with Crestest."
        },
        {
            title: "Teacher Resources",
            subtitle: "Empower your classroom with automated tools, management systems, and test builders."
        },
        {
            title: "Student Hub",
            subtitle: "Master your curriculum, assess your standing, and collaborate with peers."
        },
        {
            title: "For Parents",
            subtitle: "Track growth insights, monitor performance, and streamline your child's education.",
            isComingSoon: true
        }
    ];

    return (
        <>
            {/* Existing Hero Section */}
            <section
                className="hero-section"
                style={{
                    backgroundImage: `url(${heroBg})`,
                }}
            >
                <Navbar />

                <div className="container hero-content">
                    <div className="row align-items-center">
                        {/* Left Section (Increased Width) */}
                        <div className="col-lg-7 col-md-12 mb-4 mb-lg-0">
                            <div className="hero-left">
                                <p className="hero-small-text">AI-Powered Learning Platform</p>
                                <h1 className="hero-heading">
                                    <span style={{ color: "#FBBB1B" }}>
                                        Crestest Learning
                                    </span>
                                    &nbsp; Ventures : Transforming Education Through Innovation
                                </h1>
                                <p className="hero-sub-text" style={{ color: 'white' }}>
                                    We create engaging educational experiences and innovative
                                    digital learning solutions that inspire growth, creativity,
                                    and success.
                                </p>
                                <a
                                    href="https://crestestlearning.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn hero-btn"
                                >
                                    FREE TRIAL
                                </a>
                            </div>
                        </div>

                        {/* Right Section (Circles) */}
                        <div className="col-lg-5 col-md-12">
                            <div className="hero-right">
                                {/* Big Circle Image */}
                                <div className="hero-circle-wrapper hero-big-circle">
                                    <div className="gradient-border-wrap">
                                        <img
                                            src={heroImage}
                                            alt="Hero Main"
                                            className="hero-circle-img"
                                        />
                                    </div>
                                </div>

                                {/* Small Overlapping Circle Image */}
                                <div className="hero-circle-wrapper hero-small-circle">
                                    <div className="gradient-border-wrap">
                                        <img
                                            src={heroImage2}
                                            alt="Hero Secondary"
                                            className="hero-circle-img"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Sleek 6-Box Features Section with Zero Section Padding */}
            <section className="features-section">
                <div className="container px-0">
                    <div className="row g-0">

                        {/* Feature Box 1 */}
                        <div
                            className="col-md-4 col-lg-2 feature-box-wrapper"
                            onMouseEnter={() => setActiveTooltip('one')}
                            onMouseLeave={() => setActiveTooltip(null)}
                        >
                            <div className="feature-box box-blue">
                                <img src={icon1} alt="Icon" className="feature-icon" />
                                <h3 className="feature-title">PREMIER LEARNING HUB </h3>
                            </div>
                            {activeTooltip === 'one' && (
                                <div className="feature-hover-tooltip-card shadow-lg">
                                    <h4 className="tooltip-heading">{featureDetails.one.title}</h4>
                                    <p className="tooltip-desc">{featureDetails.one.desc}</p>
                                    <ul className="tooltip-points-list">
                                        {featureDetails.one.points.map((pt, idx) => (
                                            <li key={idx}><FaCheckCircle className="tooltip-check-icon" /> {pt}</li>
                                        ))}
                                    </ul>
                                    <div className="text-center mt-3">
                                        <button
                                            className="feature-goto-btn"
                                            onClick={() => window.open("https://lms.crestest.com/page-login", "_blank")}
                                        >
                                            Go To <FaArrowRight className="ms-1" />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Feature Box 2 */}
                        <div
                            className="col-md-4 col-lg-2 feature-box-wrapper"
                            onMouseEnter={() => setActiveTooltip('two')}
                            onMouseLeave={() => setActiveTooltip(null)}
                        >
                            <div className="feature-box box-green">
                                <img src={icon2} alt="Icon" className="feature-icon" />
                                <h3 className="feature-title">SCHOLARS’ FORUM & QUIZ ARENA</h3>
                            </div>
                            {activeTooltip === 'two' && (
                                <div className="feature-hover-tooltip-card shadow-lg">
                                    <h4 className="tooltip-heading">{featureDetails.two.title}</h4>
                                    <p className="tooltip-desc">{featureDetails.two.desc}</p>
                                    <ul className="tooltip-points-list">
                                        {featureDetails.two.points.map((pt, idx) => (
                                            <li key={idx}><FaCheckCircle className="tooltip-check-icon" /> {pt}</li>
                                        ))}
                                    </ul>
                                    <div className="text-center mt-3">
                                        <button
                                            className="feature-goto-btn"
                                            onClick={() => window.open("https://forum.crestest.com/", "_blank")}
                                        >
                                            Go To <FaArrowRight className="ms-1" />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Feature Box 3 */}
                        <div
                            className="col-md-4 col-lg-2 feature-box-wrapper"
                            onMouseEnter={() => setActiveTooltip('three')}
                            onMouseLeave={() => setActiveTooltip(null)}
                        >
                            <div className="feature-box box-orange">
                                <img src={icon3} alt="Icon" className="feature-icon" />
                                <h3 className="feature-title">KIRNAVALI NATIONAL CHALLENGE PORTAL</h3>
                            </div>
                            {activeTooltip === 'three' && (
                                <div className="feature-hover-tooltip-card shadow-lg">
                                    <h4 className="tooltip-heading">{featureDetails.three.title}</h4>
                                    <p className="tooltip-desc">{featureDetails.three.desc}</p>
                                    <ul className="tooltip-points-list">
                                        {featureDetails.three.points.map((pt, idx) => (
                                            <li key={idx}><FaCheckCircle className="tooltip-check-icon" /> {pt}</li>
                                        ))}
                                    </ul>
                                    <div className="text-center mt-3">
                                        <button
                                            className="feature-goto-btn"
                                            onClick={() => {
                                                setActiveTooltip(null);
                                                setShowComingSoonModal(true);
                                            }}
                                        >
                                            Go To <FaArrowRight className="ms-1" />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Coming Soon Modal */}
                        {showComingSoonModal && (
                            <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                                <div className="modal-dialog modal-dialog-centered">
                                    <div className="modal-content shadow-lg border-0 rounded-4 text-center p-4">

                                        <div className="modal-header border-0 pb-0 justify-content-end">
                                            <button type="button" className="btn-close" onClick={handleCloseComingSoonModal}></button>
                                        </div>

                                        <div className="modal-body px-3 py-2">
                                            <div className="mb-3 text-primary" style={{ fontSize: '42px' }}>
                                                <FaRocket />
                                            </div>
                                            <h4 className="fw-bold mb-3" style={{ color: '#207AB4' }}>Coming Soon!</h4>
                                            <p className="text-muted mb-4">
                                                The <strong>Kirnavali National Challenge Portal</strong> is currently under development and will be launching shortly. Stay tuned for exciting academic challenges!
                                            </p>
                                            <button
                                                type="button"
                                                className="btn px-4 py-2 rounded-pill fw-bold"
                                                style={{ backgroundColor: '#FBBB1B', color: '#1e293b' }}
                                                onClick={handleCloseComingSoonModal}
                                            >
                                                Got It
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Feature Box 4 */}
                        <div
                            className="col-md-4 col-lg-2 feature-box-wrapper"
                            onMouseEnter={() => setActiveTooltip('four')}
                            onMouseLeave={() => setActiveTooltip(null)}
                        >
                            <div className="feature-box box-purple">
                                <img src={icon4} alt="Icon" className="feature-icon" />
                                <h3 className="feature-title">CRESTEST SCHOOL ERP</h3>
                            </div>
                            {activeTooltip === 'four' && (
                                <div className="feature-hover-tooltip-card shadow-lg">
                                    <h4 className="tooltip-heading">{featureDetails.four.title}</h4>
                                    <p className="tooltip-desc">{featureDetails.four.desc}</p>
                                    <ul className="tooltip-points-list">
                                        {featureDetails.four.points.map((pt, idx) => (
                                            <li key={idx}><FaCheckCircle className="tooltip-check-icon" /> {pt}</li>
                                        ))}
                                    </ul>
                                    <div className="text-center mt-3">
                                        <button
                                            className="feature-goto-btn"
                                            onClick={() => window.open("https://school.crestest.com/", "_blank")}
                                        >
                                            Go To <FaArrowRight className="ms-1" />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Feature Box 5 */}
                        <div
                            className="col-md-4 col-lg-2 feature-box-wrapper"
                            onMouseEnter={() => setActiveTooltip('five')}
                            onMouseLeave={() => setActiveTooltip(null)}
                        >
                            <div className="feature-box box-red">
                                <img src={icon5} alt="Icon" className="feature-icon" />
                                <h3 className="feature-title">CUSTOM EDTECH SOFTWARE SOLUTIONS</h3>
                            </div>
                            {activeTooltip === 'five' && (
                                <div className="feature-hover-tooltip-card shadow-lg">
                                    <h4 className="tooltip-heading">{featureDetails.five.title}</h4>
                                    <p className="tooltip-desc">{featureDetails.five.desc}</p>
                                    <ul className="tooltip-points-list">
                                        {featureDetails.five.points.map((pt, idx) => (
                                            <li key={idx}><FaCheckCircle className="tooltip-check-icon" /> {pt}</li>
                                        ))}
                                    </ul>
                                    <div className="text-center mt-3">
                                        <button
                                            className="feature-goto-btn"
                                            onClick={() => window.open("https://software.crestest.com/", "_blank")}
                                        >
                                            Go To <FaArrowRight className="ms-1" />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Feature Box 6 */}
                        <div
                            className="col-md-4 col-lg-2 feature-box-wrapper"
                            onMouseEnter={() => setActiveTooltip('six')}
                            onMouseLeave={() => setActiveTooltip(null)}
                        >
                            <div className="feature-box box-teal">
                                <img src={icon6} alt="Icon" className="feature-icon" />
                                <h3 className="feature-title">MOBILE APPLICATION</h3>
                            </div>
                            {activeTooltip === 'six' && (
                                <div className="feature-hover-tooltip-card shadow-lg">
                                    <h4 className="tooltip-heading">{featureDetails.six.title}</h4>
                                    <p className="tooltip-desc">{featureDetails.six.desc}</p>
                                    <ul className="tooltip-points-list">
                                        {featureDetails.six.points.map((pt, idx) => (
                                            <li key={idx}><FaCheckCircle className="tooltip-check-icon" /> {pt}</li>
                                        ))}
                                    </ul>
                                    <div className="text-center mt-3">
                                        <button
                                            className="feature-goto-btn"
                                            onClick={() =>
                                                window.open(
                                                    "https://play.google.com/store/apps/details?id=com.schemaphic.crestest&pcampaignid=web_share",
                                                    "_blank"
                                                )
                                            }
                                        >
                                            Go To <FaArrowRight className="ms-1" />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </section>

            {/* 3. NEW: Split Content & Image Section */}
            <section className="info-section">
                <div className="container">
                    <div className="row align-items-stretch">

                        {/* Left Side Content */}
                        <div className="col-lg-6 d-flex align-items-center">
                            <div className="info-left-content">
                                <p className="info-small-text">DISCOVER CRESTEST</p>

                                <h2 className="info-heading">
                                    Empowering Every Student to Learn & Succeed
                                </h2>

                                {/* The Zigzag Accent */}
                                <div className="zigzag-border mb-3"></div>

                                <p className="info-sub-text">
                                    Crestest is an AI-powered learning platform that helps students learn smarter through personalized practice, performance insights, and engaging assessments for school and competitive exams.
                                </p>

                                <p className="info-sub-text mt-3">
                                    Explore board exam preparation, competitive test series, the free{" "}
                                    <a
                                        href="https://crestestlearning.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="wiki-link"
                                    >
                                        Try Before You Buy
                                    </a>{" "}
                                    portal,{" "}
                                    <Link
                                        to="/forum"
                                        className="wiki-link"
                                    >
                                        Scholars' Forum
                                    </Link>
                                    , and the nationwide{" "}
                                    <span
                                        className="wiki-link"
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => {
                                            setActiveTooltip(null);
                                            setShowComingSoonModal(true);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" || e.key === " ") {
                                                setActiveTooltip(null);
                                                setShowComingSoonModal(true);
                                            }
                                        }}
                                    >
                                        Kirnavali Challenge
                                    </span>
                                    —all designed to build confidence and academic success.
                                </p>

                                <Link to="/about" className="btn info-btn mt-3">
                                    EXPLORE NOW
                                </Link>
                            </div>
                        </div>

                        {/* Right Side Image (Full Width & Height of Grid Box) */}
                        <div className="col-lg-6 px-0">
                            <div className="info-right-img-wrap">
                                <img
                                    src={aboutImage}
                                    alt="About Us"
                                    className="info-full-image"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* 4. NEW: Expandable Grid Grid Section */}
            <section
                className="dynamic-grid-section"
                style={{ backgroundImage: `url(${dynamicBg})` }}
            >
                <div className="container">

                    {/* Section Header */}
                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-lg-8 d-flex flex-column align-items-center">
                            <p className="cards-small-text">CRESTEST OFFERS</p>
                            <h2 className="cards-main-heading">The Courses</h2>
                            <div className="zigzag-border"></div>
                        </div>
                    </div>

                    {/* Responsive 4-Column Grid Array */}
                    <div className="row g-4 justify-content-center transition-grid">
                        {visibleBoxes.map((box) => (
                            <div className="col-sm-6 col-md-4 col-lg-3" key={box.id}>
                                <div className="grid-item-card">
                                    <div className="grid-thumb-wrap">
                                        <img src={box.img} alt={box.title} className="grid-card-img" />
                                    </div>
                                    <div className="grid-card-body text-center">
                                        <h4 className="grid-title">{box.title}</h4>
                                        <p className="grid-subtitle">{box.subtitle}</p>
                                        <a href={box.link} className="btn grid-action-btn">
                                            VIEW DETAILS
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Expandable Pagination Control Button */}
                    {allBoxes.length > 4 && (
                        <div className="row mt-5">
                            <div className="col-12 text-center">
                                <button
                                    className="btn view-more-toggle-btn"
                                    onClick={() => setShowAll(!showAll)}
                                >
                                    {showAll ? "SHOW LESS" : "VIEW MORE"}
                                </button>
                            </div>
                        </div>
                    )}

                </div>
            </section>

            {/* 5. NEW: Staggered Circles Section */}
            {/* Original Section - Exactly as requested without changes */}
            <section
                className="circles-section"
                style={{ backgroundImage: `url(${circlesBg})` }}
            >
                <div className="container">
                    <div className="row justify-content-center align-items-center g-2">

                        {/* Circle 1 - Register Here */}
                        <div
                            className="col-6 col-md-3 d-flex justify-content-center"
                            onClick={() => setActiveModalIndex(0)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="stagger-circle circle-up bg-circle-blue">
                                <div className="circle-inner-content">
                                    <FaUserPlus className="circle-icon" />
                                    <h4 className="circle-heading">Register Here</h4>
                                </div>
                            </div>
                        </div>

                        {/* Circle 2 - Teacher Resources */}
                        <div
                            className="col-6 col-md-3 d-flex justify-content-center"
                            onClick={() => setActiveModalIndex(1)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="stagger-circle circle-down bg-circle-green">
                                <div className="circle-inner-content">
                                    <FaChalkboardTeacher className="circle-icon" />
                                    <h4 className="circle-heading">Teacher Resources</h4>
                                </div>
                            </div>
                        </div>

                        {/* Circle 3 - Student Hub */}
                        <div
                            className="col-6 col-md-3 d-flex justify-content-center"
                            onClick={() => setActiveModalIndex(2)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="stagger-circle circle-up bg-circle-orange">
                                <div className="circle-inner-content">
                                    <FaUserGraduate className="circle-icon" />
                                    <h4 className="circle-heading">Student Hub</h4>
                                </div>
                            </div>
                        </div>

                        {/* Circle 4 - For Parents */}
                        <div
                            className="col-6 col-md-3 d-flex justify-content-center"
                            onClick={() => setActiveModalIndex(3)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="stagger-circle circle-down bg-circle-purple">
                                <div className="circle-inner-content">
                                    <FaUsers className="circle-icon" />
                                    <h4 className="circle-heading">For Parents</h4>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* Dynamic Interactive Modal Popup */}
            {activeModalIndex !== null && (
                <div className="custom-modal-backdrop" onClick={() => setActiveModalIndex(null)}>
                    <div className="custom-modal-dialog" onClick={(e) => e.stopPropagation()}>

                        {/* Modal Header */}
                        <div className="custom-modal-header">
                            <div>
                                <h3 className="custom-modal-title">{circleModalConfig[activeModalIndex].title}</h3>
                                <p className="custom-modal-subtitle">{circleModalConfig[activeModalIndex].subtitle}</p>
                            </div>
                            <button className="custom-modal-close" onClick={() => setActiveModalIndex(null)}>
                                <FaTimes />
                            </button>
                        </div>

                        {/* Modal Body: Conditional Rendering for Coming Soon vs Regular Grid */}
                        <div className="custom-modal-body">
                            {circleModalConfig[activeModalIndex].isComingSoon ? (
                                <div className="coming-soon-container py-5 text-center">
                                    <div className="coming-soon-icon-wrapper mb-3">
                                        <FaHourglassHalf className="coming-soon-main-icon" />
                                    </div>
                                    <h4 className="coming-soon-title">Exciting Features on the Way!</h4>
                                    <p className="coming-soon-text">
                                        Our dedicated portal and analytical tools for parents are currently under development. Stay tuned for updates that will help you track and empower your child's learning journey.
                                    </p>
                                    <button
                                        className="btn btn-outline-primary px-4 py-2 mt-2 font-weight-bold"
                                        onClick={() => setActiveModalIndex(null)}
                                    >
                                        Got it, Thanks!
                                    </button>
                                </div>
                            ) : (
                                <div className="row g-4">
                                    {serviceTabs.map((tab, idx) => (
                                        <div className="col-md-6 d-flex align-items-stretch" key={idx}>
                                            <div className="service-card-item">

                                                {/* Card Image & Title Header */}
                                                <div className="service-card-top">
                                                    <div className="service-card-img-wrapper">
                                                        <img src={tab.image} alt={tab.name} className="service-card-img" />
                                                    </div>
                                                    <h5 className="service-card-name">{tab.name}</h5>
                                                </div>

                                                {/* Pointers list */}
                                                <ul className="service-card-pointers">
                                                    {tab.pointers.map((point, pIdx) => (
                                                        <li key={pIdx}>
                                                            <FaCheckCircle className="pointer-check-icon" />
                                                            <span>{point}</span>
                                                        </li>
                                                    ))}
                                                </ul>

                                                {/* Action Button */}
                                                <div className="service-card-footer mt-auto">
                                                    <a
                                                        href={tab.linkUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="service-card-btn"
                                                    >
                                                        {tab.linkText} <FaArrowRight className="ms-2" />
                                                    </a>
                                                </div>

                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            )}

            {/* 6. NEW: Three Cards Section */}
            <section
                className="cards-section"
                style={{ backgroundImage: `url(${cardsBg})` }}
            >
                <div className="container">

                    {/* Section Header (Center Aligned) */}
                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-lg-8 d-flex flex-column align-items-center">
                            <p className="cards-small-text">OUR PROGRAMS</p>
                            <h2 className="cards-main-heading">Explore Our Specialization</h2>
                            <div className="zigzag-border"></div>
                        </div>
                    </div>

                    {/* Cards Row */}
                    <div className="row g-4 justify-content-center">

                        {/* Card 1 */}
                        <div className="col-md-4">
                            <div className="program-card bg-card-yellow">
                                <div className="card-img-wrap">
                                    <img src={cardImg1} alt="Online Exams" className="card-top-img" />
                                </div>
                                <div className="card-body-content text-center d-flex flex-column align-items-center">
                                    <h3 className="card-heading">Online Exams</h3>
                                    <div className="zigzag-border mini-zigzag"></div>
                                    <p className="card-sub-text">
                                        An intuitive LMS that guides students through self-assessment, personalized learning paths, and online tests to measure progress.
                                    </p>
                                    <Link to="/online-exam" className="btn glass-btn">
                                        LEARN MORE
                                    </Link>
                                </div>
                            </div>
                        </div>

                        {/* Card 2 */}
                        <div className="col-md-4">
                            <div className="program-card bg-card-teal">
                                <div className="card-img-wrap">
                                    <img src={cardImg2} alt="e-Library" className="card-top-img" />
                                </div>
                                <div className="card-body-content text-center d-flex flex-column align-items-center">
                                    <h3 className="card-heading ">e-Library</h3>
                                    <div className="zigzag-border mini-zigzag"></div>
                                    <p className="card-sub-text ">
                                        Access concept maps, notes, webinars, and AI-assisted Q&A that make learning visual, interactive, and engaging.
                                    </p>
                                    {/* Card 2 */}
                                    <Link to="/e-library" className="btn glass-btn glass-btn-dark">
                                        LEARN MORE
                                    </Link>
                                </div>
                            </div>
                        </div>

                        {/* Card 3 */}
                        <div className="col-md-4">
                            <div className="program-card bg-card-blue">
                                <div className="card-img-wrap">
                                    <img src={cardImg3} alt="Performance Scorecard" className="card-top-img" />
                                </div>
                                <div className="card-body-content text-center d-flex flex-column align-items-center">
                                    <h3 className="card-heading">Performance Scorecard</h3>
                                    <div className="zigzag-border mini-zigzag"></div>
                                    <p className="card-sub-text">
                                        Track progress with detailed graphs and analytics that highlight strengths, weaknesses, and opportunities for improvement.
                                    </p>
                                    {/* Card 3 */}
                                    <Link to="/performance-scorecard" className="btn glass-btn">
                                        LEARN MORE
                                    </Link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* Download App Section */}
            <DownloadApp />

            {/* 7. NEW: Overlapping Dual Card Section */}
            <section
                className="twin-cards-section"
                style={{ backgroundImage: `url(${twinBg})` }}
            >
                <div className="container">

                    {/* Section Header (Center Aligned) */}
                    <div className="row justify-content-center text-center twin-header-margin">
                        <div className="col-lg-8 d-flex flex-column align-items-center">
                            <p className="cards-small-text">WHY CRESTEST</p>
                            <h2 className="cards-main-heading">
                                Smarter Learning, Better Results
                            </h2>
                            <div className="zigzag-border"></div>
                        </div>
                    </div>

                    {/* Dual Cards Row */}
                    <div className="row g-5 justify-content-center twin-row-padding">

                        {/* Left Card */}
                        <div className="col-md-6 col-lg-5">
                            <div className="overlap-card">

                                <div className="floating-top-circle bg-circle-accent1">
                                    <img src={circle2Icon1} alt="AI-Powered Learning" className="floating-circle-icon" />
                                </div>

                                <div className="overlap-card-body text-center d-flex flex-column align-items-center">
                                    <p className="overlap-sub-text">
                                        Personalized AI-driven learning, smart practice, and detailed performance insights help students strengthen concepts and improve results.
                                    </p>
                                    <span className="overlap-colored-action">
                                        AI-POWERED LEARNING
                                    </span>
                                </div>

                            </div>
                        </div>

                        {/* Right Card */}
                        <div className="col-md-6 col-lg-5">
                            <div className="overlap-card">

                                <div className="floating-top-circle bg-circle-accent2">
                                    <img src={circle2Icon2} alt="Complete Learning Ecosystem" className="floating-circle-icon" />
                                </div>

                                <div className="overlap-card-body text-center d-flex flex-column align-items-center">
                                    <p className="overlap-sub-text">
                                        From online exams and e-Library resources to performance analytics and academic challenges, Crestest provides a complete learning ecosystem.
                                    </p>
                                    <span className="overlap-colored-action highlight-action-yellow">
                                        COMPLETE ECOSYSTEM
                                    </span>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </section>



            {/* 8. NEW: Modular Newsletter Component */}
            <NewsLetter />

            {/* 9. NEW: Footer Component */}
            <Footer />
        </>
    );
}

export default Home;